import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('good_job_lets_review_your_settings'),
    subtitle: defineMessage('activating_the_workflow__your_accounting_system'),
    saveAndActivate: defineMessage('save_and_activate'),
    saveWithoutActivating: defineMessage('save_without_activating'),
};
